import { render, staticRenderFns } from "./AppSectionCard.vue?vue&type=template&id=821631e0&scoped=true"
import script from "./AppSectionCard.vue?vue&type=script&lang=js"
export * from "./AppSectionCard.vue?vue&type=script&lang=js"
import style0 from "./AppSectionCard.vue?vue&type=style&index=0&id=821631e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821631e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
